import React from "react";
import { useTranslation } from 'react-i18next';
import ElmaliBaiyulan from "../Components/quarries/ElmaliBaiyulan";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import productSeoData from "../data/productSeoData.json";

function ElmaliBaiyulanPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = productSeoData[currentLang]?.elmaliBaiyulan || {
    title: currentLang === 'tr' ? 'Elmalı Baiyulan Mermer - MOCA Mermer' : 'Elmali Baiyulan Marble - MOCA Marble',
    description: currentLang === 'tr' ? 'Elmalı Baiyulan mermer ürünü hakkında detaylı bilgi. MOCA Mermer kalitesi ile.' : 'Detailed information about Elmali Baiyulan marble product. With MOCA Marble quality.',
    keywords: currentLang === 'tr' ? 'elmalı baiyulan, mermer, doğal taş, moca mermer' : 'elmali baiyulan, marble, natural stone, moca marble'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/elmalibaiyulan"
        image={seo.image}
        structuredData={seo.structuredData}
      />
      <TopBar />
      <Spacer/>
      <ElmaliBaiyulan />
    </>
  );
}

export default ElmaliBaiyulanPage;
